import { useQuery } from "@tanstack/react-query";
import { fetchApi } from "@/lib/api";

interface AccessRecord {
  // Add relevant fields here
  id: string;
  // ... other fields
}

interface AccessRecordsResponse {
  data: {
    records: AccessRecord[];
  };
}

export const useGetAccessRecords = (menteeId?: string) => {
  return useQuery<AccessRecordsResponse>({
    queryKey: ["accessRecords", menteeId],
    queryFn: () =>
      fetchApi({
        url: `v2/teen-access/records/${menteeId}`,
        method: "GET",
      }),
  });
};
